import React from 'react';
import { Field, reduxForm } from 'redux-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import moment from 'moment';
import { Container, Row, Col, Button, Input } from 'reactstrap';
import SelectList from 'react-widgets/lib/SelectList';
import { australianStateOptions, patientMaritalStatusOptions, genderOptions } from '../AnswerArray';
import './PatientDetails.css';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
import NoWriteDateInput from '../NoWriteDateInput'


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

const QuestionStyle = {
  margin: 15,
};

const btnContainer = {
  color: 'white',
};

const ButtonStyle = {
  width: '30%',
  height: '50px',
  marginTop: '2%',
};

const patientStyle = {
  width: '70%',
  maxWidth: 'unset',
  marginTop: '80px',
  paddingBottom: '30px',
};

const labelStyle = {
  textAlign: 'left',
};

const answerStyle = {
  textAlign: 'left',
};

const asteriskStyle = {
  color: 'red',
};

const successStyle = {
  marginTop: '0',
  marginBottom: '1rem',
  height: '24px',
};
// Use: component for a date picker field
const renderDateSelect = ({
  input,
  type,
  meta: { touched, error, warning },
}) => (
  <div>
    <DatePicker
      {...input}
      type={type}
      onBlur={() => input.onBlur(input.value)}
      dateFormat="YYYY-MM-DD"
      onChange={date => input.onChange(moment(date).format('YYYY-MM-DD'))}
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      autoComplete="off"
      maxDate={moment()}
      placeholderText="Click to select a date"
      selected={input.value ? moment(input.value, 'YYYY-MM-DD') : null}
      normalize={value => (value ? moment(value).format('YYYY-MM-DD') : null)}
      customInput={<NoWriteDateInput />}
    />
    <div>
      {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
    </div>
  </div>
);

// Use: include in field component prop "validate" if a field is required
const required = (value, allValues) => {
  
  // Validate against input which is simply just newlines
  if (value && typeof value === "string")
  {
    value = value.replace(/\n/g, "");
  }

  const isRequired = allValues !== undefined;
  const error = 'Please fill out this field';

  const output =
    isRequired && !value ? (
      <b style={{ color: 'rgb(255,0,0)' }}>{error}</b>
    ) : null;

  return output;
};


// Use: validate for email
const validateEmail = (email) => {
  // TODO - Check if this REGEX is still valid and replace with validate.js
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // const numbers = /^[0-9]+$/;
  const error = 'This field must have a valid email address';
  const output =
      !re.test(email) && email ? (
        <b style={{ color: 'rgb(255,0,0)' }}>{error}</b>
      ) : null;

  return output;

  // return re.test(String(email).toLowerCase());
};

// Use: validation for number only answers
// Can allow for (phone) numbers to contains + and () and spaces, e.g. "+61 (20) 304212" is a valid number
// TODO: Check if this change will invalidate other forms
const integer = (value) => {
  const numbers = /^[+() 0-9]+$/;
  const error = 'This field must be a number';
  const output =
      !numbers.test(value) && value ? (
        <b style={{ color: 'rgb(255,0,0)' }}>{error}</b>
      ) : null;

  return output;
};

// Use: component for a radio button single select menu
const renderSingleSelect = ({
  input,
  data,
  valueField,
  textField,
  type,
  meta: { touched, error, warning },
}) => (
  <div>
    <SelectList
      {...input}
      onBlur={() => input.onBlur()}
      data={data}
      type={type}
      valueField={valueField}
      textField={textField}
    />
    {touched &&
    ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

// Use: render input field with checks for warnings and errors
const renderInput = ({ input, type, meta: { touched, error, warning } }) => (
  <div>
    <Input {...input} type={type} />
    <div>
      {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
    </div>
  </div>
);

// Use: component to show status of form submission once user has clicked "Save/Submit"
const ShowMessage = ({ submission, error, change }) => {
  if (submission && error === 'no error' && !change) {
    // if the submission was successful and the form is not dirty since the user clicked the save button ...
    // and the backend responds with no error, then show this message
    return (
      <p>Saved Successfully!</p>
    );
  } else if (!change && submission && (error === '' || error === null || typeof error === 'undefined')) {
    // if there is no change and the redux submission was successful meaning the user clicked the save button ...
    // but the backend hasn't given a status reporting meaning that it's still fetching, then show a spinner ...
    // to show that the submission is still in progress
    return (
      <div>
        <BeatLoader
          css={override}
          sizeUnit="px"
          size={10}
          color="#41AAD9"
        />
      </div>
    );
  }
  // otherwise show nothing
  return (
    <div style={successStyle} />
  );
};

const PatientForm = (props) => {
  const {
    handleSubmit,
    pristine,
    handleSave,
    submitting,
    submitSucceeded,
    handleChange,
    changed,
    invalid,
    noError,
  } = props;


  return (

    <div className="patient-form">
      {/* <Button style={ButtonStyle} onClick={generateToken} disabled={!submitSucceeded && !hasPatient }>Generate Token</Button> */}
      <form onSubmit={handleSubmit}>
        <Container style={patientStyle}>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's First Name<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="given"
                id="given"
                component={renderInput}
                validate={required}
                onChange={handleChange}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Surname<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="family"
                id="family"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Gender<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="gender"

                autoComplete="new-password"
                id="gender"
                onChange={handleChange}
                component={renderSingleSelect}
                validate={required}
                data={genderOptions}
                valueField="id"
                textField="display"
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Date of Birth<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="birthDate"
                autoComplete="new-password"
                id="birthDate"
                onChange={handleChange}
                component={renderDateSelect}
                validate={required}
                type="date"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">General Practitioner's Name<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="generalPractitioner"
                id="generalPractitioner"
                onChange={handleChange}
                validate={required}
                component={renderInput}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Street Address<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pAddressLine1"
                id="pAddressLine1"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Street Address 2</Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pAddressLine2"
                id="pAddressLine2"
                onChange={handleChange}
                component={renderInput}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">City/Town<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pAddressCity"
                id="pAddressCity"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">State<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pAddressState"
                autoComplete="new-password"
                id="pAddressState"
                onChange={handleChange}
                component={renderSingleSelect}
                validate={required}
                data={australianStateOptions}
                valueField="id"
                textField="display"
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Postal Code<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pAddressPC"
                id="pAddressPC"
                onChange={handleChange}
                component={renderInput}
                validate={[required, integer]}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Email<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pEmail"
                id="pEmail"
                onChange={handleChange}
                component={renderInput}
                validate={[required, validateEmail]}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Home Phone</Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pHome"
                id="pHome"
                onChange={handleChange}
                component={renderInput}
                validate={integer}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Mobile</Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="pMobile"
                id="pMobile"
                onChange={handleChange}
                component={renderInput}
                validate={integer}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Patient's Marital Status<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="maritalStatus"
                autoComplete="new-password"
                id="maritalStatus"
                onChange={handleChange}
                component={renderSingleSelect}
                validate={required}
                data={patientMaritalStatusOptions}
                valueField="id"
                textField="display"
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Next-of-Kin's First Name<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="cGiven"
                id="cGiven"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Next-of-Kin's Surname<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="cFamily"
                id="cFamily"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Next-of-Kin's Gender<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="cGender"
                autoComplete="new-password"
                id="cGender"
                onChange={handleChange}
                component={renderSingleSelect}
                validate={required}
                data={genderOptions}
                valueField="id"
                textField="display"
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Next-of-Kin's Mobile No.<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="cMobile"
                id="cMobile"
                onChange={handleChange}
                component={renderInput}
                validate={[required, integer]}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <Row style={QuestionStyle}>
            <Col style={labelStyle} xs="4">Next-of-Kin's Relationship<span style={asteriskStyle}>*</span></Col>
            <Col style={answerStyle} xs="8">
              <Input
                tag={Field}
                name="cRelationship"
                id="cRelationship"
                onChange={handleChange}
                component={renderInput}
                validate={required}
                autoComplete="new-password"
                type="text"
                style={{ width: '100%' }}
              />
            </Col>
          </Row>
          <div style={btnContainer}>
            <Button
              type="submit"
              style={ButtonStyle}
              color="success"
              disabled={pristine || submitting || invalid || (submitSucceeded && (noError === null || typeof noError === 'undefined'))}
              onClick={handleSave}
            >
                    Save
            </Button>
          </div>
          {/* <Button style={ButtonStyle} onClick={handleSave} type="submit" disabled={pristine || submitting || invalid}>Save</Button> */}
          <div>
            <ShowMessage
              submission={submitSucceeded}
              error={noError}
              change={changed}
            />

          </div>

        </Container>


      </form>
    </div>
  );
};


export default reduxForm({
  form: 'patientForm',
  destroyOnUnmount: true,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true,
  onSubmit: () => {},
  onSubmitSuccess: (val, dispatch, props) => { props.onSubmit(val); },
})(PatientForm);



// WEBPACK FOOTER //
// ./src/components/PatientDetails/PatientForm.js